module.exports = __webpack_public_path__ + "img/12.73c436a7.png";